var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"px-3 mt-1 mb-10",attrs:{"align":"center"}},[_c('h1',[_vm._v(_vm._s(_vm._f("localize")(_vm.title)))]),_c('v-divider',{staticClass:"mt-5 ml-3"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }